export class AuthResponseData {
  constructor(
    private id: string,
    private token: string,

    private email: string,
    private userType: string,
    private type: string,
  ) {}

  public get _token() {
    return this.token;
  }

  public get _userType() {
    return this.userType;
  }
  public get _email() {
    return this.email;
  }
  public get _id() {
    return this.id;
  }
  public get _type() {
    return this.type;
  }
}
